<template>
  <span @click.prevent="changeViewer">
    <div :class="[$style.iconStyle]">
      <changeViewerIcon
        :class="[$style.buttonIconPosition, $style.iconImageStyle]"
      ></changeViewerIcon>
    </div>
  </span>
</template>
<script>
import changeViewerIcon from "./assets/switch_2d_3d.svg";

export default {
  name: "vc-share-change-viewer-button",
  components: {
    changeViewerIcon
  },
  data: function() {
    return {
      changeViewerTargetElement: null
    };
  },
  props: {
    hybrid2dViewerUrl: {
      type: String,
      default: null
    },
    hybrid3dViewerUrl: {
      type: String,
      default: null
    },
    changeViewerTargetElementQuerySelector: {
      type: String,
      default: null
    },
    defaultViewerUrl: {
      type: String,
      default: ""
    },
    isIos: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.changeViewerTargetElement = document.querySelector(
      this.changeViewerTargetElementQuerySelector
    );

    //safariはブラウザバックで戻った時iframe内が更新されないため、iOSに限りiframeのsrcを更新する
    if (this.isIos) {
      this.changeViewerTargetElement.setAttribute("src", this.defaultViewerUrl);
    }
  },
  methods: {
    changeViewer: function() {
      // iframeのsrc URLから現在のビューアを判定
      const viewerUrl = this.changeViewerTargetElement.getAttribute("src");
      const matchHybrid3dRegexp = new RegExp("reader=hybrid3d$");
      const matchResultHybrid3d = viewerUrl.match(matchHybrid3dRegexp);

      if (matchResultHybrid3d) {
        this.changeViewerTargetElement.setAttribute(
          "src",
          this.hybrid2dViewerUrl
        );
        return;
      }
      this.changeViewerTargetElement.setAttribute(
        "src",
        this.hybrid3dViewerUrl
      );
    }
  }
};
</script>

<style module>
.iconStyle {
  position: relative;
  display: inline-block;
  cursor: pointer;
  height: 40px;
  width: 40px;
}

.iconImageStyle {
  height: 40px;
  width: 40px;
  object-fit: contain;
}

.buttonIconPosition {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
